import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SelectionState, EditorState } from 'draft-js';
import onClickOutside from 'react-onclickoutside';
import Youtube from 'react-youtube';
import URI from 'urijs';
import TweetEmbed from 'react-tweet-embed';
import { EDITOR_IMAGE_OPTIONS } from '../constants';


class EditorImage extends Component {
  constructor(props) {
    super(props);

    const { contentState, block } = props;
    const blockEntityType = block.getEntityAt(0);

    this.updateImageData = this.updateImageData.bind(this);

    if (!blockEntityType) {
      return null;
    }

    const entity = contentState.getEntity(blockEntityType);

    const { caption, alt, src, style, extraClasses, width } = entity.getData();
    this.state = {
      caption,
      alt,
      src,
      style,
      extraClasses: extraClasses || '',
      width,
    };
  }

  updateImageData() {
    const { caption, alt, src, style, extraClasses, width } = this.state;
    const { contentState, block } = this.props;
    const { onEditorChange, editorState } = this.props.blockProps;

    const blockEntityType = block.getEntityAt(0);
    if (!blockEntityType) {
      console.log("FML")
      return null;
    }

    const newContent = contentState.mergeEntityData(
      blockEntityType,
      { caption, alt, src, style, extraClasses, width },
    );

    onEditorChange(EditorState.push(editorState, newContent, 'change-block-data'));
  }

  handleClickOutside() {
    const { block } = this.props;
    const { editorState, resetSelection, setReadOnly } = this.props.blockProps;
    if (editorState.getSelection().getStartKey() === block.getKey() &&
      editorState.getSelection().getEndKey() === block.getKey()
      && editorState.getSelection().getHasFocus()
    ) {
      resetSelection();
      setReadOnly(false);
    }
  }

  render() {
    const { contentState, block } = this.props;
    const { editorState } = this.props.blockProps;

    const blockEntityType = block.getEntityAt(0);
    if (!blockEntityType) {
      return null;
    }
    const entity = contentState.getEntity(blockEntityType);
    // console.log(JSON.stringify(entity._map));
    const { src } = entity.getData();

    if (entity.type === 'image') {
      const { caption, alt, style, extraClasses, width } = this.state;

      let figureClass;
      switch (style) {
        case 'full-width':
          figureClass = 'figure-full';
          break;
        case 'left':
          figureClass = 'figure-left';
          break;
        case 'right':
          figureClass = 'figure-right';
          break;
        default:
          figureClass = '';
      }

      const figureBorder =
        editorState.getSelection().getStartKey() === block.getKey() &&
        editorState.getSelection().getEndKey() === block.getKey() && editorState.getSelection().getHasFocus() && '2px solid #26c281';

      let cleanedWidth;

      if (width <= 0) {
        cleanedWidth = 0;
      } else if (width && width < 50) {
        cleanedWidth = 50;
      } else {
        cleanedWidth = width;
      }

      const figureStyle = {
        width: cleanedWidth ? `${cleanedWidth}px` : '',
        border: figureBorder,
      };

      return (
        <figure
          className={`${figureClass} ${extraClasses}`}
          onClick={() => {
            const { setReadOnly, setSelection } = this.props.blockProps;
            const newSelection = SelectionState.createEmpty(block.getKey());
            const finalSelection = newSelection.merge({
              focusKey: block.getKey(),
              focusOffset: 0,
              anchorKey: block.getKey(),
              anchorOffset: 0,
            });
            setReadOnly(true);
            setSelection(finalSelection);
          }}
          style={figureStyle}
        >
        <img
          src={src}
          role="presentation"
          alt={alt}
        />
          <div
            className="figure-toolbox"
            style={
              editorState.getSelection().getStartKey() === block.getKey() &&
              editorState.getSelection().getEndKey() === block.getKey() &&
              editorState.getSelection().getHasFocus() ?
                {} : { display: 'none' }
            }
          >
            <div className="figure-toolbox-field-row">
              <div className="figure-toolbox-field">
                <label className="figure-toolbox-label">Caption</label>
                <input
                  className="figure-toolbox-input"
                  value={caption}
                  onChange={(e) => {
                    this.setState({ caption: e.target.value }, this.updateImageData);
                  }}
                />
              </div>
              <div className="figure-toolbox-field">
                <label className="figure-toolbox-label">Alt Text</label>
                <input className="figure-toolbox-input" value={alt} onChange={e => this.setState({ alt: e.target.value }, this.updateImageData)} />
              </div>
            </div>
            <div className="figure-toolbox-field-row">
              <div className="figure-toolbox-field">
                <label className="figure-toolbox-label">Align</label>
                <div className="figure-toolbox-segment clearfix">
                  <div
                    className={`figure-toolbox-segment-item ${style === 'left' && 'figure-toolbox-segment-active'}`}
                    onClick={e => this.setState({ style: 'left' }, this.updateImageData)}
                  >Left</div>
                  <div
                    className={`figure-toolbox-segment-item ${style === 'regular' && 'figure-toolbox-segment-active'}`}
                    onClick={e => this.setState({ style: 'regular' }, this.updateImageData)}
                  >Center</div>
                  <div
                    className={`figure-toolbox-segment-item ${style === 'right' && 'figure-toolbox-segment-active'}`}
                    onClick={e => this.setState({ style: 'right' }, this.updateImageData)}
                  >Right</div>
                  <div
                    className={`figure-toolbox-segment-item ${style === 'full-width' && 'figure-toolbox-segment-active'}`}
                    style={{ float: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)', clear: 'both' }}
                    onClick={e => this.setState({ style: 'full-width' }, this.updateImageData)}
                  >Full Width</div>
                </div>
              </div>
              {style !== 'full-width' && <div className="figure-toolbox-field">
                <label className="figure-toolbox-label">Width (0 is default! Minimum 50px)</label>
                <input className="figure-toolbox-input" type="number" value={width} onChange={e => this.setState({ width: e.target.value }, this.updateImageData)} />
              </div>}
              <div className="figure-toolbox-field">
                <label className="figure-toolbox-label">Extra Classes</label>
                <input className="figure-toolbox-input" value={extraClasses} onChange={e => this.setState({ extraClasses: e.target.value }, this.updateImageData)} />
              </div>
            </div>
          </div>
          {caption && <figcaption contentEditable={false}>{caption}</figcaption>}
        </figure>
      );
    } else if (entity.type === 'youtube') {
      const urlData = URI(src);
      let v;
      if (urlData.domain() === 'youtu.be') {
        v = urlData.path().slice(1, -1);
      } else if (urlData.domain() === 'youtube.com' && urlData.hasQuery('v')) {
        v = urlData.query(true).v;
      }
      return (
        <figure>
          <Youtube
            videoId={v}
            frameBorder="0"
            allowFullScreen
          />
        </figure>
      );
    } else if (entity.type === 'tweet') {
      const urlList = src.split('/');
      const tweetId = urlList[urlList.length - 1];
      return (
        <figure>
          <TweetEmbed id={tweetId} />
        </figure>
      );
    }
  }
}

export default onClickOutside(EditorImage);

EditorImage.propTypes = {
  contentState: PropTypes.object,
  block: PropTypes.object,
  blockProps: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/cms/form/editor/EditorImage.js